export default __webpack_public_path__ + "faq-section.png";